module.exports = __webpack_public_path__ + "img/icon-category-foodtruck-bg.2b5dc1fd.jpg";